export enum FileUnits {
  B = 'B',
  KB = 'KB',
  MB = 'MB',
  GB = 'GB'
}

export const zipMimeTypes = [
  'application/zip',
  'application/x-zip-compressed',
  'application/vnd.rar',
  'application/x-rar-compressed',
  'multipart/x-zip'
] as const;

export const allowedMimeTypes = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats',
  'application/x-zip-compressed',
  'application/zip',
  'image/avif',
  'image/gif',
  'image/heic',
  'image/jpeg',
  'image/png',
  'image/webp',
  'text/csv',
  'text/plain'
];

export const deniedExtensions = ['.exe', '.bin', '.hex'];

export const storageFolder = 'storage';

export function fileKeyToDownloadUrl(s3BaseUrl: string, fileKey: string): string {
  const urlParts = fileKey.split('/');

  let decodedComponent;
  try {
    decodedComponent = decodeURIComponent(urlParts[urlParts.length - 1]);
  } catch {
    // If, for any reason, the component CANNOT be decoded, then it is likely an invalid file name to begin with,
    // and will not be downloadable anyway.
    decodedComponent = urlParts[urlParts.length - 1];
  }

  urlParts[urlParts.length - 1] = encodeURIComponent(decodedComponent);
  const sanitizedValue = urlParts.join('/');
  return `${s3BaseUrl}/${sanitizedValue}`;
}

export function urlToFileKey(s3BaseUrl: string, url: string): string {
  return url.replace(`${s3BaseUrl}/`, '');
}

export const convertBytes = (bytes: number, conversionUnit: FileUnits) => {
  const unitIndex = Object.values(FileUnits).indexOf(conversionUnit);
  return bytes / 1024 ** unitIndex;
};

export const MAX_ALLOWED_FILES_UPLOAD = 10;

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB

export const ALLOWED_FILE_EXTENSIONS =
  /\.(?:png|jpe?g|bmp|webp|heic|heif|pdf|txt|csv|zip|xlsx?)$/iu;

export const ALLOWED_FILE_MIME_TYPES_REGEX = new RegExp(
  '^(?:image/(?:png|jpeg|bmp|x-bmp|webp|heic|heif|heic-sequence|heif-sequence)|text/(?:plain|csv)|' +
    'application/(?:x-zip-compressed|zip|pdf|vnd\\.ms-excel|' +
    'vnd\\.openxmlformats-officedocument\\.spreadsheetml\\.sheet))$',
  'u'
);

export const BOL_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB
export const BOL_ALLOWED_FILE_EXTENSIONS = /\.(?:png|jpe?g|heic|heif|pdf)$/iu;
export const BOL_ALLOWED_MIME_TYPES_REGEX =
  /^(?:image\/(?:png|jpeg|heic|heif|heic-sequence|heif-sequence)|application\/pdf)$/u;
